import { Component, For } from "solid-js";

export const errorId = (prefixId: string, index: number) =>
  `${prefixId}-error-${index}`;

const FormControlErrors: Component<{
  for: string;
  errors?: false | (string | { message: string })[];
}> = (props) => (
  <For each={props.errors || ([] as string[])}>
    {(error, index) => (
      <div class="invalid-feedback ms-3 mb-3" id={errorId(props.for, index())}>
        {typeof error === "string" ? error : error.message}
      </div>
    )}
  </For>
);

export default FormControlErrors;
